import { defineComponent as v, useCssModule as C, ref as h, computed as E, watch as B, openBlock as s, createElementBlock as c, normalizeClass as a, unref as t, createElementVNode as o, createCommentVNode as p, Fragment as L, renderList as w, withDirectives as $, renderSlot as S, toDisplayString as x, vShow as j, nextTick as q } from "vue";
import A from "../../utils/uid.mjs";
const D = ["id"], N = ["id"], O = ["aria-controls", "aria-label"], V = ["href", "onClick"], I = /* @__PURE__ */ v({
  name: "CdrBreadcrumb",
  __name: "CdrBreadcrumb",
  props: {
    /**
      * Sets the array of a breadcrumb object containing a 'url' and 'name' property.
      * @demoIgnore true
      */
    items: {
      type: Array,
      default: () => [],
      validator: (r) => {
        if (r.length && r.length > 0)
          for (let e = 0; e < r.length; e += 1) {
            if (typeof r[e].item != "object")
              return console.error("Breadcrumb items array missing item key at index ", e), !1;
            if (!Object.hasOwnProperty.call(r[e].item, "name"))
              return console.error("Breadcrumb items array is missing item.name value at index ", e), !1;
          }
        return !0;
      }
    },
    /**
     * Controls the ability to truncate the entire breadcrumb path. If this value is false, truncation will no longer occur.
     */
    truncationEnabled: {
      type: Boolean,
      default: !0
    },
    /**
     * Define a custom ID for the `<nav>` element. Randomly generated if no ID provided.
     * @demoIgnore true
     */
    id: {
      type: String
    }
  },
  emits: {
    /**
    * Emits when a breadcrumb item is clicked. `e.preventDefault()` may be used to override the default link navigation.
    * @param breadcrumb The breadcrumb data object
    */
    navigate: null
  },
  setup(r) {
    const e = r, i = C(), m = e.id ? e.id : A(), d = h(e.truncationEnabled && e.items.length > 2), f = h(null), _ = h(null), g = E(() => {
      const n = e.items.length - 2 > 1 ? "s" : "";
      return `show ${e.items.length - 2} more navigation level${n}`;
    }), y = () => {
      d.value = !1, q(() => {
        var n, u;
        _.value = (n = f.value) == null ? void 0 : n.querySelector("li a"), (u = _.value) == null || u.focus();
      });
    };
    return B(() => e.items, () => {
      d.value = e.truncationEnabled && e.items.length > 2;
    }), (n, u) => (s(), c("nav", {
      class: a(t(i)["cdr-breadcrumb"]),
      id: t(m),
      "aria-label": "breadcrumbs"
    }, [o("ol", {
      id: `${t(m)}List`,
      class: a(t(i)["cdr-breadcrumb__list"]),
      ref_key: "itemListEl",
      ref: f
    }, [d.value ? (s(), c("li", {
      key: 0,
      class: a(t(i)["cdr-breadcrumb__item"])
    }, [o("button", {
      onClick: y,
      "aria-expanded": "false",
      class: a(t(i)["cdr-breadcrumb__ellipses"]),
      "aria-controls": `${t(m)}List`,
      "aria-label": g.value
    }, [o("span", {
      class: a(t(i)["cdr-breadcrumb__ellipses-icon"]),
      "aria-hidden": "true"
    }, " . . . ", 2)], 10, O), o("span", {
      class: a(t(i)["cdr-breadcrumb__delimiter"]),
      "aria-hidden": "true"
    }, " / ", 2)], 2)) : p("", !0), (s(!0), c(L, null, w(r.items, (l, b) => $((s(), c("li", {
      class: a(t(i)["cdr-breadcrumb__item"]),
      key: l.item.id || l.item.name.replace(/ /g, "-").toLowerCase()
    }, [S(n.$slots, "link", {
      class: a(t(i)["cdr-breadcrumb__link"]),
      href: l.item.url,
      content: l.item.name
    }, () => [o("a", {
      class: a(t(i)["cdr-breadcrumb__link"]),
      href: l.item.url,
      onClick: (k) => n.$emit("navigate", l, k)
    }, x(l.item.name), 11, V)]), b < r.items.length - 1 ? (s(), c("span", {
      key: 0,
      class: a(t(i)["cdr-breadcrumb__delimiter"]),
      "aria-hidden": "true"
    }, " / ", 2)) : p("", !0)], 2)), [[j, !d.value || b >= r.items.length - 2]])), 128))], 10, N)], 10, D));
  }
});
export {
  I as default
};
